export const name = 'close';

export const Close = () => (
  <svg viewBox="0 0 24 24" color="#161616" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.46631 5.46631L18.5336 18.5336"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M5.46631 18.5337L18.5336 5.46636"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
  </svg>
);
